import axios from "axios";
import React, { useEffect, useState } from "react";
import getBrowserFingerprint from 'get-browser-fingerprint';
import { useNavigate } from "react-router-dom";
import { Base64 } from "js-base64";
import loadericon from "../../assets/img/Rollingnew.svg";
import { useTranslation } from "react-i18next";

export default function FeedbackSurvey({ idTraineData: propIdTraineData = 1080  }) {
  const { t } = useTranslation(["surveyPage"]);

  const bottomContent = t("bottomContent", { returnObjects: true });
  const bottomContentArray = Array.isArray(bottomContent)
    ? bottomContent
    : (bottomContent ? Object.values(bottomContent) : []);

  const completeSurveyBtnObj = bottomContentArray.find(item => item.id === "button_uniqueIdentifer_1");
  const completeSurveyBtnLabel = completeSurveyBtnObj?.value || "COMPLETE SURVEY";
  const completeSurveyBtnError = completeSurveyBtnObj?.errorText || "Please select an option before moving to the next question.";

  const surveyContent = t("surveyContent", { returnObjects: true });
  const surveyContentArray = Array.isArray(surveyContent)
    ? surveyContent
    : (surveyContent ? Object.values(surveyContent) : []);

  const [selectedOptions, setSelectedOptions] = useState({});
  const [errorQuestions, setErrorQuestions] = useState([]);
  const fingerprint = getBrowserFingerprint();
 const [isloader, setIsloader] = useState(false);
const history = useNavigate();
  const [feedbackQuestions, setQuizQuestions] = useState([]);
  useEffect(() => {
      const fetchQuiz = async () => {
        try {
          let idTraineData = localStorage.getItem("idTraineData")
            ? parseInt(localStorage.getItem("idTraineData"), 10)
            : propIdTraineData;
  
          if (idTraineData === null) {
            localStorage.setItem("PID", Base64.encode(fingerprint + "P1"));
            return;
          }
          const res = await axios.post(
            process.env.REACT_APP_API_ENDPOINT + "/getsurvey",
            { idTraineData }
          );
  
          if (res.data && Array.isArray(res.data)) {
            setQuizQuestions(res.data); // Assuming API returns quiz questions array
          } 
        } catch (error) {
          
          
        }
      };
      fetchQuiz();
    }, [fingerprint, propIdTraineData]);

 const handleSelect = (quesId, ans_id) => {
  setSelectedOptions(prev => ({
    ...prev,
    [quesId]: ans_id,
  }));
  // Remove error for this question if present
  setErrorQuestions(prev => prev.filter(errorId => errorId !== quesId));
};

const handleMultiSelect = (quesId, ans_id) => {
  setSelectedOptions(prev => {
    const selected = prev[quesId] || [];
    let newSelected;
    if (selected.includes(ans_id)) {
      newSelected = selected.filter(id => id !== ans_id);
    } else {
      newSelected = [...selected, ans_id];
    }
    // After updating, remove error if answered
    if (newSelected.length > 0) {
      setErrorQuestions(prev => prev.filter(errorId => errorId !== quesId));
    }
    return { ...prev, [quesId]: newSelected };
  });
};

const handleInput = (quesId, value) => {
  setSelectedOptions(prev => ({
    ...prev,
    [quesId]: value,
  }));
  
};

const sanitizeValue = (str = "") => {
  return String(str).replace(/[^a-zA-Z0-9 .,\-_'"?!:;()\n\r]/g, "");
};

const handleTextareaChange = (quesId, e) => {
  const cleaned = sanitizeValue(e.target.value);
  handleInput(quesId, cleaned);
};

const buildSurveyPayload = () => {
  const surveyData = feedbackQuestions.map(q => {
    let submittedOpts;
    
    if (q.type === "multiselect") {
      submittedOpts = selectedOptions[q.id] || [];
    } else {
      const value = selectedOptions[q.id];
      // [] for empty/null, [value] otherwise - no "" or null
      submittedOpts = (value == null || value === "") ? [] : [value];
    }

    return {
      quesId: q.id,
      description: q.description,
      submittedOpts,
      type: (q.type === "textarea" || q.type === "input") ? "input" : q.type,
      allAvailableValues: Array.isArray(q.values)
        ? q.values.map(opt => ({
            ans_id: opt.ans_id,
            description: opt.description,
          }))
        : [],
    };
  });

  const idTraineData = localStorage.getItem("idTraineData")
    ? parseInt(localStorage.getItem("idTraineData"), 10)
    : propIdTraineData;

  return {
    idTraineData,
    surveyData,
  };
};





  const handleSubmit = async () => {
    
    const encoded = localStorage.getItem("payloadsubmit");  

    let errors = [];
    for (const q of feedbackQuestions) {

      if (q.type === "textarea") continue;

      const ans = selectedOptions[q.id];

      
      if (q.type === "multiselect") {
        if (!ans || !Array.isArray(ans) || ans.length === 0) {
          errors.push(q.id);
        }
      } else if (!ans || ans === "") {
        errors.push(q.id);
      }
    }
    setErrorQuestions(errors);
    if (errors.length > 0) {
      return; // Don't submit if errors exist
    }
    setIsloader(true);
    const payload = buildSurveyPayload();
    try {
      const res = await axios.post(
        process.env.REACT_APP_API_ENDPOINT + "/submitsurvey",
        payload
      );
      if (res) {

        if (encoded !== null) {
  const idTraineDataStr = encoded ? Base64.decode(encoded) : '';
  // If the original payload was an object (via JSON.stringify), parse it:
  const payloadObj = JSON.parse(idTraineDataStr);
  
   const res = await axios.post(
        process.env.REACT_APP_API_ENDPOINT + "/submittraineedata",
        payloadObj
      );

      // return;
      if (res && res.data.status === 1) {
         const plain_text_BPA_CV_WithCity =
                  res.data.values.promoteragency.AgencyCity !== ""
                    ? res.data.values.promoteragency.PromoterAgencyName +
                      ",\n" +
                      res.data.values.promoteragency.AgencyCity
                    : res.data.values.promoteragency.PromoterAgencyName;
                    
        // return;
                const plain_text_BPA_CV =
                  res.data.values.promoteragency.AgencyLocation !== ""
                    ? res.data.values.promoteragency.AgencyCity !== ""
                      ? plain_text_BPA_CV_WithCity +
                        ", " +
                        res.data.values.promoteragency.AgencyLocation
                      : plain_text_BPA_CV_WithCity +
                        ",\n" +
                        res.data.values.promoteragency.AgencyLocation
                    : plain_text_BPA_CV_WithCity;
        
                
                localStorage.setItem(
                  "plain_text_NAME_CV",res.data.values.fullName
                );
                localStorage.setItem(
                  "plain_text_DATE_CV",
                    Base64.encode(res.data.values.certificationDate)
                );
                
        
                localStorage.setItem(
                  "plain_text_CSN_CV",
                    Base64.encode(res.data.values.certificateNumber)
                );
        
        
        
        
                localStorage.setItem(
                  "plain_text_BPA_CV",
                  Base64.encode(plain_text_BPA_CV)
                );
        
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                  event: "customEvent",
                  eventCategory: "Button",
                  eventAction: "Button/Page View",
                  eventLabel: "GOAL",
                  eventValue: "Successful",
                });
                localStorage.setItem("PID", Base64.encode(fingerprint + "P6"));
                history("/");
                window.location.reload();
                setIsloader(false);
              
      }
}
        
       
      } else {
        alert("There was an error submitting the Survey. Please try again.");
      }
    } catch (err) {
      
      setIsloader(false);
    }
  };

  return (
    <div className="mt-3">
      {feedbackQuestions.map((q, qIndex) => (
        <div
          key={q.id}
          className={`mb-4 ${errorQuestions.includes(q.id) ? "error-question" : ""}`}
        >
          <h6>
            {qIndex + 1}. {q.description} {q.type !== "textarea" && <span className="text-danger">*</span> }
          </h6>
          {/* Select (single choice) */}
          {q.type === "select" && (
            <>
              <div className="list-group quiz-options-list">
                {q.values.map((opt, index) => (
                  <button
                    key={opt.ans_id}
                    className={`quiz-options${
                      selectedOptions[q.id] === opt.ans_id ? " active text-white" : ""
                    }`}
                    onClick={() => handleSelect(q.id, opt.ans_id)}
                    type="button"
                  >
                    {opt.description}
                  </button>
                ))}
              </div>
              {errorQuestions.includes(q.id) && (
                <div className="text-danger mt-1" style={{ fontSize: "0.9rem" }}>
                  {
                    surveyContentArray.find(item => item.id === q.id || item.section === q.section)?.errorText ||
                    q.errorText ||
                    completeSurveyBtnError ||
                    "This question is required."
                  }
                </div>
              )}
            </>
          )}
          {/* Multiselect */}
          {q.type === "multiselect" && (
            <>
              <div className="list-group quiz-options-list">
                {q.values.map((opt, index) => (
                  <button
                    key={opt.ans_id}
                    className={`quiz-options${
                      (selectedOptions[q.id] || []).includes(opt.ans_id)
                        ? " active text-white"
                        : ""
                    }`}
                    onClick={() => handleMultiSelect(q.id, opt.ans_id)}
                    type="button"
                  >
                    {opt.description}
                  </button>
                ))}
              </div>
              {errorQuestions.includes(q.id) && (
                <div className="text-danger mt-1" style={{ fontSize: "0.9rem" }}>
                  {
                    surveyContentArray.find(item => item.id === q.id || item.section === q.section)?.errorText ||
                    q.errorText ||
                    completeSurveyBtnError ||
                    "This question is required."
                  }
                </div>
              )}
            </>
          )}
          {/* Text Input */}
          {q.type === "input" && (
            <>
              <input
                type="text"
                className="form-control"
                value={selectedOptions[q.id] || ""}
                onChange={e => handleInput(q.id, e.target.value)}
              />
              {errorQuestions.includes(q.id) && (
                <div className="text-danger mt-1" style={{ fontSize: "0.9rem" }}>
                  {
                    surveyContentArray.find(item => item.id === q.id || item.section === q.section)?.errorText ||
                    q.errorText ||
                    completeSurveyBtnError ||
                    "Comment is required."
                  }
                </div>
              )}
            </>
          )}
          {/* Textarea */}
          {q.type === "textarea" && (
            
              <textarea
                className="form-control"
                rows={4}
                value={selectedOptions[q.id] || ""}
                // onChange={e => handleInput(q.id, e.target.value)}
                onChange={e => handleTextareaChange(q.id, e)}
                onKeyPress={e => {
                  const char = e.key;
                  if (char && char.length === 1 && /[^a-zA-Z0-9 .,\-_'"?!:;()]/.test(char)) {
                    e.preventDefault();
                  }
                }}
                onPaste={e => {
                  e.preventDefault();
                  const paste = (e.clipboardData || window.clipboardData).getData('text');
                  const cleaned = sanitizeValue(paste);
                  const prev = selectedOptions[q.id] || "";
                  handleInput(q.id, prev + cleaned);
                }}
              />
              
            
          )}
        </div>
      ))}
      <div className="mt-4 text-end">
        <button onClick={handleSubmit} className="btn-quiz-next " disabled={isloader}>
          {completeSurveyBtnLabel} {isloader ? <img alt="loading" className="loaderbtnimg" width={25}  height={25} src={loadericon} />: ""}
        </button>
      </div>
    </div>
  );
}
